import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { usePlans } from '../../api/hooks/usePlans';
import { SUBSCRIPTION } from '../../interfaces/enumerables';
import { selectSelectedCompany } from '../../store/companies/companiesSlice';
import { isPlanCovered } from './planUtils';

export const usePlanIsActive = (planId: SUBSCRIPTION) => {
  const company = useSelector(selectSelectedCompany);
  const { data, isLoading, isError } = usePlans(company?.vatNumber || '');

  const isPlanActive = useCallback(() => isPlanCovered(data?.activePlans, planId), [data?.activePlans, planId]);

  // Something is off with the server => let user use the app
  if (isError) return true;

  return isLoading || isPlanActive();
};
